module.exports = __webpack_public_path__ + "img/329f568.jpg";